<template>
  <v-container grid-list-sm>
    <home-cards />
    <v-layout>
      <tcloud-comp class="xs12">
        <template v-slot:title>Traguardi mensili</template>
        <template v-slot:toolbar-extra>
          <v-btn @click="expandTotali" dark flat color="primary">
            <v-icon dark>mdi-arrow-expand-all</v-icon>
          </v-btn>
        </template>
        <totale-mensile ref="totaleMensile" />
      </tcloud-comp>
    </v-layout>
    <v-layout>
      <tcloud-comp class="xs12">
        <template v-slot:title>Gli ultimi conti</template>
        <datatable
          preset="venduto"
          name="home"
          limit/>
      </tcloud-comp>
    </v-layout>
    <v-layout wrap>
      <tcloud-comp class="xs12 sm6">
        <template v-slot:title>I 5 articoli più venduti</template>
        <top-articoli-oggi />
      </tcloud-comp>
      <tcloud-comp class="xs12 sm6">
        <template v-slot:title>Nuovi clienti</template>
        <nuovi-clienti />
      </tcloud-comp>
    </v-layout>
  </v-container>
</template>

<script>
import Stats from '@/mixins/stats';
import HomeCards from '@/components/home/HomeCards.vue';
import Datatable from '@/components/Datatable.vue';
import TotaleMensile from '@/components/home/TotaleMensile.vue';
import TopArticoliOggi from '@/components/home/TopArticoliOggi.vue';
import NuoviClienti from '@/components/home/NuoviClienti.vue';

export default {
  name: 'home',
  mixins: [Stats],
  components: {
    HomeCards,
    TotaleMensile,
    Datatable,
    TopArticoliOggi,
    NuoviClienti,
  },
  methods: {
    expandTotali() {
      this.$refs.totaleMensile.showYear = true;
    },
  },
};
</script>
